// libraries
import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';

export type DealerIdResolver = (state: any) => unknown;

type DealerIdStore = {
    getState: () => any;
    subscribe: (listener: () => void) => () => void;
};

export const resolveDealerIdFromDealerSlice: DealerIdResolver = (state) => (state.dealer ?? state.__global?.dealer)?.dealerId;

export const subscribeDealerIdToSession = (
    store: DealerIdStore,
    resolveDealerId: DealerIdResolver = resolveDealerIdFromDealerSlice
): (() => void) => {
    let lastWritten: string | undefined;

    const sync = () => {
        try {
            const dealerId = resolveDealerId(store.getState());
            const next = dealerId == null ? '' : String(dealerId);

            if (next === lastWritten) return;

            offerSessionUtils.setDealerId(next);
            lastWritten = next;
        } catch (error) {
            lastWritten = undefined;
        }
    };

    sync();
    return store.subscribe(sync);
};
